import { render, staticRenderFns } from "./PhyitemReg.vue?vue&type=template&id=658ba98a&"
import script from "./PhyitemReg.vue?vue&type=script&lang=js&"
export * from "./PhyitemReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports